export const LOADING = 'loading';
export const READY = 'ready';
export const SHARE_COMPLETE = 'share-complete';